module.exports = __webpack_public_path__ + "static/media/flower.c22fe86b.png";